// Shared dark-theme styles for the Social Listening page.

export const inputDarkSx = {
  '& .MuiOutlinedInput-root': {
    color: '#f4f4f5',
    '& fieldset': { borderColor: '#52525b' },
    '&:hover fieldset': { borderColor: '#71717a' },
    '&.Mui-focused fieldset': { borderColor: '#818cf8' },
  },
  '& .MuiInputLabel-root': { color: '#d4d4d8' },
  '& .MuiSvgIcon-root': { color: '#a1a1aa' },
};

export const paperSx = {
  bgcolor: '#1c1c22',
  border: '1px solid #3f3f46',
  color: '#f4f4f5',
  p: 2.5,
};

// MUI default Chip = near-black text on faint selected bg — invisible on this dark page.
export const neutralChipSx = { bgcolor: '#3f3f46', color: '#e4e4e7' } as const;
